class WorkWithUs {
  constructor(sectionId) {
    this.el = document.querySelector(`[data-section-id="${sectionId}"]`);
    if (!this.el) return;
    this._syncPending = false;
    this._observers = [];
    this.init();
  }

  init() {
    const target = this.el.querySelector('[data-allibo-widget]') || this.el.querySelector('.aw_jobList') || this.el;

    this._mainObserver = new MutationObserver(() => this.applyAllStyles());
    this._mainObserver.observe(target, { childList: true, subtree: true });
    this._observers.push(this._mainObserver);

    this.el.addEventListener('click', (e) => {
      const pageLink = e.target.closest('.aw_pagerLink');
      if (!pageLink) return;
      this.scrollToSection();
    });

    const viewport = this.el.querySelector('.aw_viewport');
    if (viewport) {
      this._pageObserver = new MutationObserver(() => this.syncPaginationState());
      this._pageObserver.observe(viewport, { attributes: true, attributeFilter: ['class', 'style'], subtree: true });
      this._observers.push(this._pageObserver);
    }

    this.applyAllStyles();
    this.el.classList.add('__ready');
  }

  applyAllStyles() {
    this.moveSearchButton(this.el.querySelectorAll('.aw_searchBox:not([data-moved])'));
    this.replaceSearchButton(this.el.querySelectorAll('.aw_searchButton:not([data-styled])'));
    this.wrapSelects(this.el.querySelectorAll('.aw_select:not([data-wrapped])'));
    this.replaceApplyLink(this.el.querySelectorAll('.aw_applyLink:not([data-styled])'));
    this.replacePinIcons(this.el.querySelectorAll('.aw_pin:not([data-replaced])'));
    this.replacePagination(this.el.querySelectorAll('.aw_pager:not([data-styled])'));
    this.syncPaginationState();
  }

  wrapSelects(selects) {
    selects.forEach((select) => {
      select.setAttribute('data-wrapped', '');
      const wrapper = document.createElement('div');
      wrapper.className = 'select';
      select.parentNode.insertBefore(wrapper, select);
      wrapper.appendChild(select);
      wrapper.insertAdjacentHTML(
        'beforeend',
        `<svg class="icon icon-caret-down icon--2xs icon--thick" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.25 7.5L10 13.75L3.75 7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>`,
      );
    });
  }

  replaceSearchButton(buttons) {
    buttons.forEach((div) => {
      div.setAttribute('data-styled', '');
      const btn = div.querySelector('button');
      if (!btn) return;

      btn.className = 'btn btn--primary btn--icon-circle';
      btn.innerHTML = `<span class="btn__text flex items-center gap-x-2"><span class="button-item__icon flex"><svg xmlns="http://www.w3.org/2000/svg" class="icon icon-search icon--medium icon--thick" viewBox="0 0 24 24" fill="none"><path d="M10.875 18.75C15.2242 18.75 18.75 15.2242 18.75 10.875C18.75 6.52576 15.2242 3 10.875 3C6.52576 3 3 6.52576 3 10.875C3 15.2242 6.52576 18.75 10.875 18.75Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M16.4434 16.4453L20.9997 21.0016" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></span></span>`;

      div.parentNode.insertBefore(btn, div);
      div.remove();
    });
  }

  replacePinIcons(pins) {
    pins.forEach((pin) => {
      pin.setAttribute('data-replaced', '');
      pin.insertAdjacentHTML(
        'afterend',
        `<svg class="icon icon-location icon--medium icon--thick shrink-0" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M4.375 18.125H15.625" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10 10.625C11.3807 10.625 12.5 9.50571 12.5 8.125C12.5 6.74429 11.3807 5.625 10 5.625C8.61929 5.625 7.5 6.74429 7.5 8.125C7.5 9.50571 8.61929 10.625 10 10.625Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M16.25 8.125C16.25 13.75 10 18.125 10 18.125C10 18.125 3.75 13.75 3.75 8.125C3.75 6.4674 4.40848 4.87769 5.58058 3.70558C6.75269 2.53348 8.3424 1.875 10 1.875C11.6576 1.875 13.2473 2.53348 14.4194 3.70558C15.5915 4.87769 16.25 6.4674 16.25 8.125Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>`,
      );
      pin.remove();
    });
  }

  replacePagination(pagers) {
    const page = this.getTotalPages();

    if (page <= 1) {
      this.el.querySelector('.aw_pager')?.remove();
      return;
    }

    pagers.forEach((pager) => {
      pager.setAttribute('data-styled', '');

      const links = pager.querySelectorAll('.aw_pagerLink');
      if (!links.length) return;

      const currentPageId = this.getCurrentPageId();

      const nav = document.createElement('nav');
      nav.className = 'pagination text-center';
      nav.setAttribute('role', 'navigation');
      nav.setAttribute('aria-label', 'Paginazione');

      const ul = document.createElement('ul');
      ul.className = 'pagination__list list-unstyled flex items-center flex-wrap justify-center';
      ul.setAttribute('role', 'list');

      links.forEach((link) => {
        const li = document.createElement('li');
        const originalId = link.id || '';
        const pageId = link.getAttribute('data-pageid') || '';
        const isBack = originalId.includes('pageNavBack');
        const isNext = originalId.includes('pageNavNext');
        const isCurrent = pageId && pageId === currentPageId;

        link.className = `aw_pagerLink pagination__item${isCurrent ? ' pagination__item--current background-2' : ''}`;
        if (isBack) {
          link.classList.add('pagination__item--previous', 'pagination__item-arrow', 'motion-reduce', 'is-disabled');
        } else if (isNext) {
          link.classList.add('pagination__item--next', 'pagination__item-arrow', 'motion-reduce');
        }

        if (isBack) {
          link.innerHTML = '';
          link.insertAdjacentHTML(
            'beforeend',
            `<svg class="icon icon-caret-left rtl-flip-x icon--extra-small icon--thick" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.5 16.25L6.25 10L12.5 3.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>`,
          );
          const span = document.createElement('span');
          span.textContent = 'Precedente';
          link.appendChild(span);
        } else if (isNext) {
          link.innerHTML = '';
          const span = document.createElement('span');
          span.textContent = 'Successivo';
          link.appendChild(span);
          link.insertAdjacentHTML(
            'beforeend',
            `<svg class="icon icon-caret-right rtl-flip-x icon--extra-small icon--thick" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 3.75L13.75 10L7.5 16.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>`,
          );
        } else if (pageId) {
          link.textContent = link.textContent.trim();
          link.setAttribute('aria-label', `Pagina ${link.textContent}`);
          if (isCurrent) {
            link.setAttribute('aria-current', 'page');
          }
        }

        li.appendChild(link);
        ul.appendChild(li);
      });

      nav.appendChild(ul);
      pager.parentNode.insertBefore(nav, pager);
      pager.remove();
    });
  }

  getTotalPages() {
    const viewport = this.el.querySelector('.aw_viewport');
    if (!viewport) return 0;
    return viewport.querySelectorAll('.aw_page').length;
  }

  getCurrentPageId() {
    const viewport = this.el.querySelector('.aw_viewport');
    if (!viewport) return null;
    const visible = viewport.querySelector('.aw_page.is-visible');
    return visible ? visible.id : null;
  }

  syncPaginationState() {
    if (this._syncPending) return;
    this._syncPending = true;
    requestAnimationFrame(() => {
      this._syncPending = false;
      this._doSyncPaginationState();
    });
  }

  _doSyncPaginationState() {
    const nav = this.el.querySelector('.pagination');
    if (!nav) return;

    const currentPageId = this.getCurrentPageId();
    const allLinks = nav.querySelectorAll('.aw_pagerLink');
    const pageLinks = [];
    let backLink = null;
    let nextLink = null;

    allLinks.forEach((link) => {
      if (link.classList.contains('pagination__item--previous')) {
        backLink = link;
      } else if (link.classList.contains('pagination__item--next')) {
        nextLink = link;
      } else {
        pageLinks.push(link);
      }
    });

    const sorted = pageLinks.filter((l) => l.getAttribute('data-pageid'));

    pageLinks.forEach((link) => {
      const pageId = link.getAttribute('data-pageid');
      if (pageId && pageId === currentPageId) {
        link.classList.add('pagination__item--current', 'background-2');
        link.setAttribute('aria-current', 'page');
      } else {
        link.classList.remove('pagination__item--current', 'background-2');
        link.removeAttribute('aria-current');
      }
    });

    if (backLink) {
      const isFirstPage = sorted.length > 0 && currentPageId === sorted[0].getAttribute('data-pageid');
      this.toggleVisibility(backLink.closest('li'), !isFirstPage);
    }

    if (nextLink) {
      const isLastPage = sorted.length > 0 && currentPageId === sorted[sorted.length - 1].getAttribute('data-pageid');
      this.toggleVisibility(nextLink.closest('li'), !isLastPage);
    }
  }

  scrollToSection() {
    if (!this.el) return;
    window.scrollTo({
      top: this.el.getBoundingClientRect().top + window.scrollY - this.getHeaderHeight(),
      behavior: FoxTheme.config.motionReduced ? 'auto' : 'smooth',
    });
  }

  getHeaderHeight() {
    const header = document.querySelector('.header-section header[is="sticky-header"]');
    if (header) return header.offsetHeight;
    const h = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    return parseInt(h, 10) || 0;
  }

  toggleVisibility(el, visible) {
    if (!el) return;
    el.style.display = visible ? '' : 'none';
  }

  replaceApplyLink(links) {
    links.forEach((link) => {
      link.setAttribute('data-styled', '');
      const onclick = link.getAttribute('onclick') || '';

      const newLink = document.createElement('a');
      newLink.setAttribute('role', 'button');
      newLink.className = 'btn btn--primary';
      if (onclick) newLink.setAttribute('onclick', onclick);

      const wrapper = document.createElement('span');
      wrapper.className = 'btn__text flex items-center gap-x-2';

      const textSpan = document.createElement('span');
      textSpan.className = 'button-item__text';
      textSpan.textContent = link.textContent.trim();

      const iconSpan = document.createElement('span');
      iconSpan.className = 'button-item__icon flex';
      iconSpan.insertAdjacentHTML(
        'beforeend',
        `<svg class="icon icon-arrow-right icon--medium icon--thick shrink-0" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M2.8125 9H15.1875" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10.125 3.9375L15.1875 9L10.125 14.0625" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>`,
      );

      wrapper.appendChild(textSpan);
      wrapper.appendChild(iconSpan);
      newLink.appendChild(wrapper);

      link.parentNode.insertBefore(newLink, link);
      link.remove();
    });
  }

  moveSearchButton(boxes) {
    boxes.forEach((box) => {
      box.setAttribute('data-moved', '');
      const btn = box.querySelector('.aw_searchButton') || box.querySelector('button[id^="AdsFilterSearch"]');
      if (btn) box.appendChild(btn);
    });
  }

  destroy() {
    this._observers.forEach((o) => o.disconnect());
    this._observers = [];
  }
}

window.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.work-with-us[data-section-id]');
  if (section) {
    new WorkWithUs(section.dataset.sectionId);
  }
});
